import React from 'react'
import { Container as KogKContainer } from '@kogk/common'

const Container: React.FC = ({ children }) => {
  return <KogKContainer className='see-all__container page-slice-spacer'>{children}</KogKContainer>
}

export default Container
